import { render, staticRenderFns } from "./IssueHistoryTable.vue?vue&type=template&id=d30a5150&scoped=true&"
import script from "./IssueHistoryTable.vue?vue&type=script&lang=js&"
export * from "./IssueHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./IssueHistoryTable.vue?vue&type=style&index=0&id=d30a5150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30a5150",
  null
  
)

export default component.exports